"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { useIsCheckoutRoute } from "@/hooks/useIsCheckoutRoute";
import { CartSidebarContent } from "./CartSidebarContent";
import { CartSidebarSite } from "./CartSidebarSite";
interface Props {
  trustSignalsSlot?: React.ReactNode;
  optionalAddOnsSlot?: React.ReactNode;
}
export function CartSidebar(props) {
  const $ = _c(7);
  const isCheckoutRoute = useIsCheckoutRoute();
  let t0;
  if ($[0] !== props) {
    t0 = <CartSidebarContent {...props} reorderStatus="idle" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const idleSidebar = t0;
  if (isCheckoutRoute) {
    return idleSidebar;
  }
  let t1;
  if ($[2] !== props) {
    t1 = <CartSidebarSite {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== idleSidebar || $[5] !== t1) {
    t2 = <Suspense fallback={idleSidebar}>{t1}</Suspense>;
    $[4] = idleSidebar;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}